import { useState } from "react";
import { Alert } from "react-bootstrap";
import HeaderFour from "../common/header/HeaderFour";
import SEO from "../common/SEO";
import FooterOne from "../common/footer/FooterOne";
import axios from "axios";
import API_URL from "../common/config";
import { useNavigate } from "react-router-dom";

const ParentLogin = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState({});
  const navigate = useNavigate();

  const handleManualLogin = async (e) => {
    e.preventDefault();
    const newError = {};
    if (!formData.email) {
      newError.email = "Email is required";
    }
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newError.email = "Please provide a valid email address";
    }
    if (!formData.password) {
      newError.password = "Password is required";
    }
    if (Object.keys(newError).length > 0) {
      setError(newError);
      return;
    }
    setError({});
    console.log("Form Data:", formData);
    try {
      const response = await axios.post(`${API_URL}/parent/login`, formData);
      if (response.data.success) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("session", response.data.session);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        localStorage.setItem("parentData", JSON.stringify(response.data.data));
        localStorage.setItem("parentId", response.data.data._id);
        navigate("/parent-dashboard");
      } else {
        console.error("Login failed:", response.data.message);
        setError({ general: response.data.message || "Login failed" });
      }
    } catch (error) {
      console.error("Login failed:", error);
      setError({ general: "Login failed. Please try again." });
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <>
      <SEO />
      <main className="main-wrapper">
        <HeaderFour />
        <div
          className="section section-padding"
          style={{ position: "relative" }}
        >
          <div className="container mt-5">
            <div className="row justify-content-center">
              <div className="col-xl-5 col-lg-6">
                <div className="contact-form-box shadow-box">
                  <h3 className="title text-center">Parent Login</h3>
                  <h5 className="text-center">
                    Don't have access?
                    <span
                      style={{
                        color: "#6600CC",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      &nbsp;Request Access
                    </span>
                  </h5>
                  <form
                    onSubmit={handleManualLogin}
                    className="axil-contact-form"
                  >
                    <div className="form-group">
                      <label>Email address*</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="example@gmail.com"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <div className="text-danger fs-6 mx-2">{error.email}</div>
                    </div>
                    <div className="form-group">
                      <label>Password*</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="******"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      <div className="text-danger fs-6 mx-2">
                        {error.password}
                      </div>
                    </div>
                    <div className="form-group gap-2 flex-row">
                      <button
                        type="submit"
                        className="axil-btn try-free-btn btn-fluid btn-primary"
                        name="submit-btn"
                      >
                        Log In
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <ul className="shape-group-8 list-unstyled">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-9.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-11.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-4.png"}
                alt="Line"
              />
            </li>
          </ul>
        </div>
        <FooterOne />
      </main>
    </>
  );
};

export default ParentLogin;
